module.exports = __webpack_public_path__ + "img/icon_utility.3a5d60e0.png";